var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["partials/account-navigation-links-dashboard.j2"] = require( "partials/account-navigation-links-dashboard.j2" );
dependencies["partials/wishlist-nav-accordion.j2"] = require( "partials/wishlist-nav-accordion.j2" );
dependencies["partials/account-navigation-links-additional.j2"] = require( "partials/account-navigation-links-additional.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation-links.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("partials/account-navigation-links-dashboard.j2", false, "core/templates/partials/account-navigation-links.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n<li class=\"o-secondary-navigation__li\">\n    <a class=\"o-secondary-navigation__a ";
output += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "helpers") && (lineno = 3, colno = 113, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"urlContains"), "helpers[\"urlContains\"]", context, ["account-settings"])))?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 3, colno = 162, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["account-settings"])), env.opts.autoescape);
output += "\" data-link-name=\"account-settings\" data-qa-my-account-nav=\"account_navigation-accountSettings\">\n        ";
output += runtime.suppressValue((lineno = 4, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-accountSettings",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"o-secondary-navigation__li\">\n    <a class=\"o-secondary-navigation__a ";
output += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "helpers") && (lineno = 9, colno = 113, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"urlContains"), "helpers[\"urlContains\"]", context, ["address"])))?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 9, colno = 153, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["address"])), env.opts.autoescape);
output += "\" data-link-name=\"address\" data-qa-my-account-nav=\"account_navigation-addressAndPayments\">\n        ";
output += runtime.suppressValue((lineno = 10, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-addressAndPayments",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"o-secondary-navigation__li\">\n    <a class=\"o-secondary-navigation__a ";
output += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "helpers") && (lineno = 15, colno = 113, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"urlContains"), "helpers[\"urlContains\"]", context, ["orders"])))?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 15, colno = 151, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ordersUrl"), "ordersUrl", context, [])), env.opts.autoescape);
output += "\" data-link-name=\"orders\" data-qa-my-account-nav=\"account_navigation-orderHistory\">\n        ";
output += runtime.suppressValue((lineno = 16, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-orderHistory",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"o-secondary-navigation__li ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "wishlist") && (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_mobile") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small"))?"o-secondary-navigation__li--accordion o-accordion__tabset js-accordion-tabset is-expanded":""), env.opts.autoescape);
output += "\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "wishlist")) {
output += "\n        ";
env.getTemplate("partials/wishlist-nav-accordion.j2", false, "core/templates/partials/account-navigation-links.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n    ";
})});
}
else {
output += "\n        <a class=\"o-secondary-navigation__a\" href=\"";
output += runtime.suppressValue((lineno = 25, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "wishlistUrl"), "wishlistUrl", context, [])), env.opts.autoescape);
output += "\" data-link-name=\"wishlist\" data-qa-my-account-nav=\"account_navigation-wishLists\">\n            ";
output += runtime.suppressValue((lineno = 26, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-wishLists",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n        </a>\n    ";
;
}
output += "\n\n</li>\n\n";
env.getTemplate("partials/account-navigation-links-additional.j2", false, "core/templates/partials/account-navigation-links.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n";
if((lineno = 34, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.profile.membership"]))) {
output += "\n<li class=\"o-secondary-navigation__li\">\n    <a class=\"o-secondary-navigation__a\" href=\"";
output += runtime.suppressValue((lineno = 36, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["membership"])), env.opts.autoescape);
output += "\" data-link-name=\"account-membership\" data-qa-my-account-nav=\"account_navigation-membership\">\n        ";
output += runtime.suppressValue((lineno = 37, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-membership",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation-links.j2"] , dependencies)